import React from 'react';

import Login from "Login";
import DirectPaymentHomepage from "DirectPaymentHomepage";
import DirectPayment from "DirectPayment";
import DirectPaymentResult from "DirectPaymentResult";

import Accueil from "./views/Recouveo/Accueil/Accueil";
import AccueilAfterPay from "./views/Recouveo/Accueil/AccueilAfterPay";
import NouveauMessage from "./views/Recouveo/NouveauMessage/NouveauMessage";
import Messagerie from "./views/Recouveo/Messagerie/MessageView";
import Informations from "./views/Recouveo/Informations/Informations.js";

export const publicRoutes = [
    { path: '/login', name: 'Login', element: <Login /> },
    { path: '/a/:token', name: 'AutoLogin', element: <Login /> },
    { path: '/p/result', element: <DirectPaymentResult /> },
    { path: '/p/result/:id/:response', name: 'DirectPaymentResult', element: <DirectPaymentResult /> },
    { path: '/p', name: 'DirectPaymentHomepage', element: <DirectPaymentHomepage /> },
    { path: '/p/:token', name: 'DirectPayment', element: <DirectPayment /> }
]

export const protectedRoutes = [
    { path: '/informations', name: 'UserInfosBtoC', element: <Informations /> },
    { path: '/messagerie', name: 'Messagerie', element: <Messagerie /> },
    { path: '/nouveauMessage', name: 'NouveauMessage', element: <NouveauMessage /> },
    { path: '/accueil/:accueilParam1?/:accueilParam2?', name: 'Accueil', element: <Accueil /> },
    { path: '/afterpay', name: 'AfterPay', element: <AccueilAfterPay /> }
]